export default "__VITE_ASSET__CTxiVao5__"